import { NextSeo } from "next-seo";
import dynamic from "next/dynamic";
import Layout from "@/components/layout";

const Top = dynamic(() => import("@/components/contact-us/top"), {
  suspense: true,
});

const Info = dynamic(() => import("@/components/contact-us/info"), {
  suspense: true,
});

const Form = dynamic(() => import("@/components/contact-us/form"), {
  suspense: true,
});

export default function ContactUs() {
  return (
    <Layout>
      <NextSeo
        title="Upgrade Your Business with ISO Certification. Contact Now"
        canonical="https://isauditr.com/contact-us"
        description="Contact with the Best ISO Auditors and get the best solutions for the growth of your business. Book a call and we’ll reach out to you at the earliest."
        twitter={{
          cardType: "summary_large_image",
          site: "@isauditr",
          handle: "@isauditr",
          creator: "@isauditr",
          title: "Upgrade Your Business with ISO Certification. Contact Now",
          description:
            "Contact with the Best ISO Auditors and get the best solutions for the growth of your business. Book a call and we’ll reach out to you at the earliest.",
        }}
        openGraph={{
          type: `website`,
          locale: `en_US`,
          siteName: "IS Auditr",
          title: "Upgrade Your Business with ISO Certification. Contact Now",
          description:
            "Contact with the Best ISO Auditors and get the best solutions for the growth of your business. Book a call and we’ll reach out to you at the earliest.",
          url: `https://isauditr.com/contact-us`,
          publisherName: "IS Auditr",
          publisherLogo: "https://isauditr.com/images/logo.svg",
        }}
      />

      <div
        data-elementor-type="wp-page"
        data-elementor-id="30"
        className="elementor elementor-30"
      >
        <Top
          title="want to work together?"
          subTitle="Contact us, and let’s discover how we can help your organization become even greater."
        />
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-be11077 elementor-section-full_width elementor-reverse-mobile elementor-section-height-default elementor-section-height-default"
          data-id="be11077"
          data-element_type="section"
        >
          <div className="elementor-container elementor-column-gap-no">
            <Info />
            <Form />
          </div>
        </section>
      </div>
    </Layout>
  );
}
